import { sha256 } from 'js-sha256';
import { SECTIONS_ORDER } from "../config/constants";

// Sorting array of arrays by 1st column as sections and headers as 1st row
function sortAOABySection(rows) {
    const orderMap = new Map(SECTIONS_ORDER.map((item, index) => [item.toLowerCase(), index]));

    // Sort the rows based on the first column using the SECTIONS_ORDER (case-insensitive)
    rows.sort((a, b) => {
        const aCategory = a[0].toLowerCase();
        const bCategory = b[0].toLowerCase();

        const aOrder = orderMap.get(aCategory);
        const bOrder = orderMap.get(bCategory);

        // If both sections are found in the SECTIONS_ORDER, compare their order
        if (aOrder !== undefined && bOrder !== undefined) {
            return aOrder - bOrder;
        }

        // If one section is not in the SECTIONS_ORDER, place it at the end
        if (aOrder === undefined && bOrder === undefined) {
            return 0;  // If both are not in the SECTIONS_ORDER, leave as is
        }

        return aOrder === undefined ? 1 : -1;  // If a is undefined, push it to the end; otherwise, b goes to the end
    });

    // Recombine header with sorted rows
    return rows;
}

const formatDecimalToFixed2 = (value, { withoutTypeCheck = true, defaultValue = 'N/A' } = {}) => {
    if (withoutTypeCheck) {
        return (isNaN(Number(value)) ? defaultValue : Number(value).toFixed(2)) ?? defaultValue;
    }
    if (typeof value === 'number') {
        if (Number.isInteger(value)) {
            return value;
        } else {
            return Number(value).toFixed(2);
        }
    }
    return value;
};

function recursivelyFormatObject(obj) {
    if (Array.isArray(obj)) {
        return obj.map(recursivelyFormatObject);
    } else if (obj !== null && typeof obj === 'object') {
        const formatted = {};
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                formatted[key] = recursivelyFormatObject(obj[key]);
            }
        }
        return formatted;
    } else {
        return formatDecimalToFixed2(obj);
    }
}

function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

async function getFileHash(file) {
  const arrayBuffer = await file.arrayBuffer();
  const uint8Array = new Uint8Array(arrayBuffer);
  return sha256(uint8Array);
}

export {
    sortAOABySection,
    formatDecimalToFixed2,
    recursivelyFormatObject,
    isValidEmail,
    getFileHash,
};
